import { useFormikContext } from "formik"
import { FormHelperText } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { CreateUpdatePaymentLinkFormValues } from "../paymentLinksTypes"

export function AvailabilityDetailsField() {
    const { values, setFieldValue, errors } = useFormikContext<CreateUpdatePaymentLinkFormValues>()

    return (
        <>
            <LocalizedStrict id="payment-links-form-availability-from-date-picker" attrs={{ label: true }}>
                <DatePicker
                    value={values.availabilityDetails?.dateInterval?.from}
                    onChange={(newValue: any) => {
                        if (newValue) {
                            setFieldValue("availabilityDetails.dateInterval.from", newValue)
                        }
                    }}
                    label="From date"
                    maxDate={values.availabilityDetails?.dateInterval?.to}
                />
            </LocalizedStrict>
            <LocalizedStrict id="payment-links-form-availability-to-date-picker" attrs={{ label: true }}>
                <DatePicker
                    value={values.availabilityDetails?.dateInterval?.to}
                    onChange={(newValue: any) => {
                        if (newValue) {
                            setFieldValue("availabilityDetails.dateInterval.to", newValue)
                        }
                    }}
                    label="To date"
                    minDate={values.availabilityDetails?.dateInterval?.from}
                />
            </LocalizedStrict>
            {!!errors.availabilityDetails?.dateInterval &&
                typeof errors.availabilityDetails?.dateInterval === "string" && (
                    <FormHelperText error>{errors.availabilityDetails?.dateInterval}</FormHelperText>
                )}
        </>
    )
}
